import React from 'react';
import { LLNumberPredictionWidgetSubmitButton } from './LLNumberPredictionWidgetSubmitButton';
import {
  LLWidgetActionInfo,
  LLWidgetActionInfoProps,
  LLWidgetRewardsProps,
} from '../LLWidgetFooter';

function EmptyComponent(_: LLWidgetRewardsProps) {
  return undefined;
}

export function LLNumberPredictionWidgetActionInfo(
  props: LLWidgetActionInfoProps
) {
  return (
    <LLWidgetActionInfo
      {...props}
      SubmitButtonComponent={LLNumberPredictionWidgetSubmitButton}
      WidgetRewardsComponent={EmptyComponent}
    />
  );
}
